import { createUrlStore } from "../../../utils/createUrlStore.ts";

export type InputUrlStore<T> = {
  clear: () => void;
  getInputUrlParam: () => T | undefined;
};

export const createInputUrlStore = <T>(
  propertyName: string,
  serialize: (value: T | undefined) => string,
  deserialize: (value: string) => T | undefined,
) => {
  type State = Record<string, T | undefined>;
  type Actions = {
    clear: () => void;
    getInputUrlParam: () => T | undefined;
  };

  const state: State = { [propertyName]: undefined };
  const params = {
    [propertyName]: {
      paramName: `p_${propertyName}`,
      serialize: (value: T | undefined) => serialize(value),
      deserialize: (value: string) => deserialize(value),
    },
  };

  return createUrlStore<State, Actions>(state, params, ({ get, set }) => ({
    clear: () => {
      set({ [propertyName]: undefined });
    },
    getInputUrlParam: () => get()[propertyName],
  }));
};
